import component from './sessions.vue'

export default component
